import { isEmpty } from 'lodash';

import {
    SET_REQUEST_ID,
    SET_MERCHANT_TRANSACTION_ID,
    REQUEST_COFIDIS_ELIGIBILITY,
    SUCCESS_COFIDIS_ELIGIBILITY,
    FAILURE_COFIDIS_ELIGIBILITY,
    REQUEST_COFIDIS_INITIALIZE,
    SUCCESS_COFIDIS_INITIALIZE,
    FAILURE_COFIDIS_INITIALIZE,
    REQUEST_COFIDIS_CONFIRM,
    SUCCESS_COFIDIS_CONFIRM,
    FAILURE_COFIDIS_CONFIRM
} from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

import gtm from '../../utils/gtmUtils';
import { CALL_API } from '../../middlewares/api';
import { makeActionCreator } from '../../utils/actionsUtils';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export const setRequestId = makeActionCreator(SET_REQUEST_ID, 'requestId');
export const setMerchantTransactionId = makeActionCreator(
    SET_MERCHANT_TRANSACTION_ID,
    'merchantTransactionId'
);

export function callEligibility(formData) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/cofidis/eligibility',
            method: HTTP_METHOD_POST,
            body: formData,
            types: [
                REQUEST_COFIDIS_ELIGIBILITY,
                SUCCESS_COFIDIS_ELIGIBILITY,
                FAILURE_COFIDIS_ELIGIBILITY
            ]
        }
    };
}

export function callInitialize(formData) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/cofidis/pay',
            method: HTTP_METHOD_POST,
            body: formData,
            types: [
                REQUEST_COFIDIS_INITIALIZE,
                SUCCESS_COFIDIS_INITIALIZE,
                FAILURE_COFIDIS_INITIALIZE
            ],
            finallyCallback: () => {
                gtm.event('add_payment_info', { payment_method: 'Cofidis' });
            }
        }
    };
}

export function callConfirm(formData, callback) {
    if (isEmpty(formData)) {
        throw new Error(ERROR_FORMDATA_EMPTY);
    }
    return {
        [CALL_API]: {
            endpoint: '/cofidis/confirm',
            method: HTTP_METHOD_POST,
            body: formData,
            types: [REQUEST_COFIDIS_CONFIRM, SUCCESS_COFIDIS_CONFIRM, FAILURE_COFIDIS_CONFIRM],
            successCallback: () => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/cofidis/actions.js